<template>
    <div style="padding-right: 21px;">
        <div class="yq-page-head" v-if="template||page">
            <div class="yq-page-name">{{isTemplate?template.name:page.name}}</div>
            <div class="yq-page-toolbar">
                <date-interval-picker v-model="searchParams.timeInterval" type="daterange"></date-interval-picker>
                <el-link v-if="canAdmin" :underline="false" type="primary" @click="openAdminDialog" style="margin-left: 10px;">管理关注公司</el-link>
            </div>
        </div>
        <div>
            <div class="yq-company-monitor-category-navs-container">
                <div class="yq-company-monitor-category-navs">
                    <div v-for="nav in navData" :key="nav.title"
                         :class="{'yq-company-monitor-category-nav-selected': selectedNav===nav.title}"
                         class="yq-company-monitor-category-nav" @click="selectedNav=nav.title">
                        <div class="yq-company-monitor-category-nav-sep"></div>
                        <div class="yq-company-monitor-category-nav-button">
                            <div v-if="nav.indicator" class="yq-company-monitor-category-nav-indicator">+{{nav.indicator}}</div>
                            <div class="yq-company-monitor-category-nav-title">{{nav.title}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="yq-company-monitor-category-body">
                <company-monitor-overview v-if="selectedNav==='公司综览'" :search-params="searchParams"></company-monitor-overview>
                <company-risk-events v-else :search-params="searchParams" :type="selectedNav==='最新舆情'?'舆情':selectedNav"></company-risk-events>
            </div>
        </div>
        <el-dialog title="管理关注公司" :visible.sync="dialogFormVisible" width="600px">
            <el-row>
                <el-col :span="4" class="yq-company-monitor-label">
                    添加公司：
                </el-col>
                <el-col :span="16">
                    <autocomplete v-model="model.keyword" value-key="name" :fetch-suggestions="fetchCompanies"
                                  @select="model.company=$event" ></autocomplete>
                </el-col>
                <el-col :span="3" :offset="1" class="yq-company-monitor-buttons" style="height: 40px;">
                    <el-link type="primary" @click="addMonitoredCompany">添加</el-link>
                </el-col>
            </el-row>
            <div style="max-height: 300px;overflow: auto;">
                <el-row v-for="(item,index) in monitoredCompanies" :key="item.id" style="margin-top: 10px;">
                    <el-col :span="4" v-if="index===0" style="text-align: right;">
                        <div>已关注公司：</div>
                    </el-col>
                    <el-col :span="16" :offset="index===0?0:4" class="yq-company-monitor-center-middle">
                        <div>{{index+1}}. {{item.companyName}}</div>
                    </el-col>
                    <el-col :span="3" :offset="1" class="yq-company-monitor-buttons">
                        <el-link type="primary" @click="deleteMonitoredCompany(item.id)">删除</el-link>
                    </el-col>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import pageTemplateService from '../../service/page-template'
    import pageService from '../../service/page'
    import {mapGetters} from 'vuex'
    import CompanyMonitorOverview from './CompanyMonitorOverview'
    import CompanyRiskEvents from './CompanyRiskEvents'
    import DateIntervalPicker from '../common/DateIntervalPicker'
    import companyMonitorService from '../../service/company_monitor'
    import Autocomplete from '../common/Autocomplete'

    export default {
        name: "CompanyMonitorPage",
        components: {CompanyMonitorOverview, DateIntervalPicker, Autocomplete, CompanyRiskEvents},
        props: ["id", "isTemplate"],
        data() {
            return {
                template: null,
                page: null,
                searchParams: {
                    timeInterval: 'P3M'
                },
                navData: [
                    {title:'公司综览'},
                    {title:'最新舆情',indicator:0,type:'舆情'},
                    {title:'工商变更',indicator:0},
                    {title:'行政处罚',indicator:0},
                    {title:'裁判文书',indicator:0},
                    {title:'开庭公告',indicator:0},
                    {title:'失信人',indicator:0},
                    {title:'资产负债率过高',indicator:0}
                ],
                selectedNav: '公司综览',
                dialogFormVisible: false,
                monitoredCompanies: [],
                model: {
                    keyword: null,
                    company: null
                },
                rules: {}
            }
        },
        computed: {
            ...mapGetters(['hasAuthority', 'hasAnyAuthority']),
            canAdmin(){
                return this.hasAuthority('P_前台_管理_风险监测')
            }
        },
        watch:{
            searchParams:{
                handler(){
                    this.init()
                },
                deep: true
            }
        },
        created(){
            if(this.isTemplate){
                pageTemplateService.getPageTemplate(this.id).then(response => {
                    this.template = response.data
                    this.init()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                })
            }else{
                pageService.getPage(this.id).then(response => {
                    this.page = response.data
                    this.init()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                })
            }
        },
        methods: {
            async init(){
                await this.countEventsByType()
            },
            async countEventsByType(){
                for(const nav of this.navData){
                    if(nav.indicator!==undefined){
                        nav.indicator=0
                    }
                }
                const response = await companyMonitorService.countEventsByType(this.searchParams)
                for(const item of response.data.data){
                    for(const nav of this.navData){
                        if(nav.type&&item.key===nav.type||!nav.type&&item.key===nav.title){
                            nav.indicator=item.value
                            break
                        }
                    }
                }
            },
            async openAdminDialog(){
                await this.listMonitoredCompanies()
                this.dialogFormVisible = true
            },
            async fetchCompanies(keyword, page, callback){
                const response = await companyMonitorService.listDpsCompanies({
                    keyword,
                    page: page-1,
                    size: 10
                })
                callback({
                    rows: response.data.rows,
                    totalPages: Math.floor((response.data.total+response.data.limit-1)/response.data.limit),
                    page: Math.floor(response.data.offset/response.data.limit)+1
                })
            },
            async listMonitoredCompanies(){
                const response = await companyMonitorService.listMonitoredCompanies({page:0,size:1000})
                this.monitoredCompanies = response.data.data.content
            },
            async addMonitoredCompany(){
                if(!this.model.company){
                    return
                }
                const response = await companyMonitorService.addMonitoredCompany({
                    companyId: this.model.company.id
                })
                if(!response.data.success){
                    this.$message({
                        type: 'error',
                        message: response.data.errorMsg
                    })
                    return
                }
                await this.listMonitoredCompanies()
            },
            deleteMonitoredCompany(id){
                this.$confirm('确定要从监控列表中删除该公司吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    companyMonitorService.deleteMonitoredCompany(id).then(response=>{
                        if(!response.data.success){
                            this.$message({
                                type: 'error',
                                message: response.data.errorMsg
                            })
                            return
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                        this.listMonitoredCompanies()
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>
<style scoped>

</style>
